import { takeEvery, put } from 'redux-saga/effects';
import downloadReportActions from '../actionTypes/downloadReportActions';
import { API_CALL } from '../actionTypes/sharedActions';

function* downloadReport({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: payload.url,
      method: 'POST',
      data: payload.dataParams,
    },
    successAction: downloadReportActions.downloadReportSuccess,
    failureAction: downloadReportActions.downloadReportFailed,
  });
}

export default function* watchDownloadReport() {
  yield takeEvery(downloadReportActions.downloadReport, downloadReport);
}
